

$('<script src="https://www.youtube.com/iframe_api"></script>').appendTo('body');
window.onYouTubeIframeAPIReady = () => {
    var ytplayers = [];
    const iframes = $('.TextformatterVideoEmbed iframe[src*=youtube]').toArray();
    iframes.forEach(d => {
        const player = new YT.Player(d,{
            events:{
                onStateChange: onPlayerStateChange,
            }
        });
        ytplayers.push(player);

        function onPlayerStateChange(e){
            const $container = $(e.target.g).closest('.TextformatterVideoEmbed');


            if (e.data == YT.PlayerState.ENDED) {               
                console.log("Video Ended");
            }
    
            if (e.data == YT.PlayerState.PLAYING) {             
               $container.addClass('playing');
            }
            
            if (e.data == YT.PlayerState.PAUSED) {              
                $container.removeClass('playing');
                console.log("Video Paused");
            }
    
            if (e.data == YT.PlayerState.BUFFERING) {               
                console.log("Video Buffering");
            }
    
            if (e.data == YT.PlayerState.CUED) {                
                console.log("Video Cued");
            }
    
        }
    });

    

    window.ytplayers = ytplayers;

}
